import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white relative overflow-hidden"
    >
      <div className="px-6 md:px-12 lg:px-16 max-w-[1440px] mx-auto pt-24 md:pt-32 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-20">
          <div className="lg:col-span-5">
            <span className="eyebrow eyebrow-dark">¿Conversamos?</span>
            <h3 className="display-2 mt-4 mb-6">
              Hablemos<span className="text-[#0047FF]">.</span>
            </h3>
            <p className="text-[#A3A3A3] text-base max-w-md leading-relaxed mb-8">
              Convierte tu desafío tecnológico en una ventaja competitiva. Un asesor
              te contactará en menos de 24 horas.
            </p>
            <a
              href="/#contacto"
              data-testid="footer-cta"
              className="inline-flex items-center gap-3 border border-white/30 px-6 py-4 font-mono text-[11px] uppercase tracking-[0.18em] hover:bg-white hover:text-black transition-colors"
            >
              Iniciar proyecto
              <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow eyebrow-dark mb-5">Navegación</div>
            <ul className="space-y-3 text-[15px]">
              <li><a href="/#servicios" className="hover:text-[#0047FF] transition-colors" data-testid="footer-link-servicios">Servicios</a></li>
              <li><a href="/#diferenciadores" className="hover:text-[#0047FF] transition-colors" data-testid="footer-link-diferenciadores">Diferenciadores</a></li>
              <li><a href="/#casos" className="hover:text-[#0047FF] transition-colors" data-testid="footer-link-casos">Casos de Éxito</a></li>
              <li><a href="/#nosotros" className="hover:text-[#0047FF] transition-colors" data-testid="footer-link-nosotros">Sobre Nosotros</a></li>
              <li><a href="/#contacto" className="hover:text-[#0047FF] transition-colors" data-testid="footer-link-contacto">Contacto</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="eyebrow eyebrow-dark mb-5">Información</div>
            <ul className="space-y-3 text-[15px] text-[#D4D4D4]">
              <li>Software a medida · Apps · IA</li>
              <li>Ciudad de México · LATAM</li>
              <li>
                <Link
                  to="/aviso-de-privacidad"
                  className="underline underline-offset-4 decoration-white/30 hover:decoration-[#0047FF] hover:text-white"
                  data-testid="footer-link-privacidad"
                >
                  Aviso de Privacidad
                </Link>
              </li>
              <li className="font-mono text-[12px] tracking-wider text-[#A3A3A3]">
                Lun – Vie · 9:00 a 19:00
              </li>
            </ul>
          </div>
        </div>

        <div className="giant-text leading-none mb-12 select-none brand-crt-wrap">
          <span className="brand-crt block" data-testid="footer-brand">
            WOK<span className="lowercase font-extrabold tracking-tight"> center</span>
          </span>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#A3A3A3]">
            © {year} TI Datos y Sistemas Wok Center · Todos los derechos reservados
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#A3A3A3]">
            Hecho con rigor en LATAM
          </div>
        </div>
      </div>
    </footer>
  );
}
